export default __webpack_public_path__ + "static/media/linkedin.eb827251.svg";